import { AsyncPaginate } from "react-select-async-paginate";

import { getTenant } from "../../utils/tenantManager";
import { getScaleModelsApi } from "../../services/operation/scale/scaleModelService";

type OptionType = {
  value: string;
  label: string;
  makeName?: string;
  capacities?: any[];
  data?: any;
  __isNew__?: boolean;
};

type Additional = {
  page: number;
};

type Props = {
  value: OptionType | null;
  onChange: (value: OptionType | null) => void;
  className?: string;
};

export default function ScaleModelAsyncSelect({
  value,
  onChange,
  className,
}: Props) {
  const tenantId = getTenant();

  const loadOptions = async (
    search: string,
    _loadedOptions: readonly OptionType[],
    additional?: Additional,
  ) => {
    const page = additional?.page ?? 1;

    const res = await getScaleModelsApi(page, 10, search, tenantId!);

    const options: OptionType[] = res.data.map((x: any) => ({
      value: x.id,
      label: x.name,
      makeName: x.makeName,
      capacities: x.modelCapacities,
      data: x,
    }));

    // Add create option if model doesn't exist
    if (
      page === 1 &&
      search.trim() &&
      !options.some(
        (x) => x.label.toLowerCase() === search.trim().toLowerCase(),
      )
    ) {
      options.unshift({
        value: search.trim(),
        label: `➕ Create "${search.trim().toUpperCase()}"`,
        __isNew__: true,
      });
    }

    return {
      options,
      hasMore: page * 10 < res.totalCount,
      additional: {
        page: page + 1,
      },
    };
  };

  return (
    <AsyncPaginate
      value={value}
      loadOptions={loadOptions}
      additional={{ page: 1 }}
      debounceTimeout={300}
      isClearable
      placeholder="Search or Create Model..."
      className={className}
      onChange={(selected: any) => {
        if (selected?.__isNew__) {
          onChange({
            value: selected.value,
            label: selected.value.toUpperCase(),
            __isNew__: true,
            makeName: "",
            capacities: [],
          });
        } else {
          onChange(selected);
        }
      }}
    />
  );
}
